import { jsx as _jsx } from "react/jsx-runtime";
export var CopiedIcon = function () {
    return (_jsx("svg", { className: 'w-4 h-4', fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24', children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, d: 'M5 13l4 4L19 7' }) }));
};
